<script>
import ls from 'localstorage-slim';

export default {
	props: {
		job_id: {
			type: String
		}
	},
	created() {
		// Fetch from LS
		let seen = ls.get('esc_seen', { decrypt: false });

		// If there's nothing in local storage, initialise an empty object.
		if (seen == null) {
			seen = {};
		}

		const now = Math.round(Date.now()/1000);
		const expired = now - (60*60*24*30); // 30 days old

		// only keep items newer than the expiry date
		seen = Object.fromEntries(Object.entries(seen).filter(([key, value]) => value > expired));

		// Add or updated this job
		seen[this.job_id] = now;

		// Re-save to LS
		ls.set('esc_seen', seen, {encrypt: false});
	}
}
</script>
